export default __webpack_public_path__ + "static/media/count-number.d031f8d2.gif";